import ClaimV2DataService from "../../services/ClaimV2DataService";

const state = {
  claims: [],
  pagination: {
    count: 0,
    page: 1,
    size: 20,
    totalPages: 1,
  },
  statusCounts: {
    new: 0,
    pending: 0,
    query: 0,
    approved: 0,
    rejected: 0,
    total: 0,
  },
  isLoading: false,
  error: null,
};

const mutations = {
  SET_CLAIMS(state, payload) {
    state.claims = payload.rows || [];
    state.pagination = {
      count: payload.count || 0,
      page: payload.page || 1,
      size: payload.size || 20,
      totalPages: payload.totalPages || 1,
    };
  },
  SET_STATUS_COUNTS(state, counts) {
    state.statusCounts = counts || {
      new: 0,
      pending: 0,
      query: 0,
      approved: 0,
      rejected: 0,
      total: 0,
    };
  },
  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async fetchClaimsV2(
    { commit, dispatch },
    { page = 1, size = 20, isApproved } = {}
  ) {
    commit("SET_LOADING", true);
    try {
      const response = await ClaimV2DataService.getAll(page, size, isApproved);
      commit(
        "SET_CLAIMS",
        response.data || { rows: [], count: 0, page, size, totalPages: 1 }
      );
      commit("SET_ERROR", null);
      dispatch("fetchStatusCounts");
    } catch (e) {
      commit("SET_CLAIMS", {
        rows: [],
        count: 0,
        page: 1,
        size: 20,
        totalPages: 1,
      });
      commit("SET_ERROR", e);
    }
    commit("SET_LOADING", false);
  },
  async fetchStatusCounts({ commit }) {
    try {
      const response = await ClaimV2DataService.getStatusCounts();
      commit("SET_STATUS_COUNTS", response.data);
    } catch (e) {
      commit("SET_STATUS_COUNTS", {
        new: 0,
        pending: 0,
        query: 0,
        approved: 0,
        rejected: 0,
        total: 0,
      });
    }
  },
};

const getters = {
  allClaimsV2: (state) => state.claims,
  claimsV2Pagination: (state) => state.pagination,
  claimsV2Loading: (state) => state.isLoading,
  claimsV2Error: (state) => state.error,
  claimsV2StatusCounts: (state) => state.statusCounts,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
